import ObligationFormQuestionHelp from '../ObligationFormQuestionHelp';
import styled from 'styled-components';

export default function QuestionType3(props) {
  const { question } = props;

  return (
    <QuestionGroup>
      <div
        dangerouslySetInnerHTML={{
          __html: question.name,
        }}
      />
      <ObligationFormQuestionHelp question={question} />
    </QuestionGroup>
  );
}
const QuestionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
`;